import { Box, Flex, Text } from "@chakra-ui/react"
import Bage from "components/UI/atoms/Bage"
import Heading from "components/UI/atoms/Heading"
import { IDashboardCardProps } from "./DashboardCardTypes"
import { StyledBox, StyledFlex } from "./StyledDashboardCard"
import Icon from "components/UI/atoms/Icon"

const DashboardCard: React.FC<IDashboardCardProps> = ({
  onClick,
  title,
  icon,
  width,
  bg,
  height,
  boxshadow,
  borderRadius,
  withBadge,
  badgeValue,
  outerTitle,
  setHeadingToggle,
  iconStyles,
  isPremium,
  headingSize = "sm"
}) => {

  const defaultIconStyles = {
    fill: "#046CEC",
    width: !outerTitle ? "76px" : "20px",
    height: !outerTitle ? "76px" : "20px"
  }

  return (
    <StyledFlex
      onClick={onClick}
      width={width}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      onMouseLeave={() => setHeadingToggle && setHeadingToggle(false)}
      onMouseEnter={() => setHeadingToggle && setHeadingToggle(true)}
    >
      <StyledBox
        transition=".3s ease"
        position={"relative"}
        cursor={"pointer"}
        _hover={{ background: "primary" }}
        width={width}
        bg={bg}
        height={height}
        boxShadow={boxshadow}
        borderRadius={borderRadius}
      >
        {withBadge && (
          <Bage
            BageStyles={{ backgroud: "Primary" }}
            top={"0"}
            right={"0"}
            value={badgeValue || ""}
          />
        )}
        <Flex
          gap={"20px"}
          h={"100%"}
          w={"100%"}
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Icon
            name={icon}
            iconStyles={iconStyles || defaultIconStyles}
          />
          {(isPremium || !outerTitle) && (
            <Box>
              {isPremium && <Text fontSize="base" mt="0" mb="5px">Qapp <strong>Premium</strong></Text>}
              {!outerTitle && <Heading title={title} variant="bold" size={headingSize} />}
            </Box>
          )}
        </Flex>
      </StyledBox>
      {outerTitle && (
        <Heading
          className="outlined-text"
          title={title}
          variant="bold"
          size={headingSize}
        />
      )}
    </StyledFlex>
  )
}

export default DashboardCard
